/* eslint-disable @typescript-eslint/no-unused-vars */
import { useLazyQuery } from '@apollo/client';
import { WidgetCode } from 'component/popup/constant';
import WidgetPopup from 'component/popup/customize_popup';
import { STYLIST_SUGGESTION } from 'graph_ql/search/stylist_suggestion';
import { AlgoliaInput, AlgoliaResponse, AlgoliaSuggestionHits } from 'graph_ql/types/types';
import React, { HTMLProps, useEffect, useState } from 'react';

import { RootState, useAppSelector } from '../../redux/store';
import { useStyles } from './style';

interface IHeaderFilterProps extends HTMLProps<HTMLDivElement> {
    handler?: any;
    setInputSearch?: any;
    value?: any;
    disableSuggestions?: boolean;
}

function StylistHeaderFilter(rest: IHeaderFilterProps) {
    const { value = '' } = rest;
    const classes = useStyles();
    const [showPopup, setShowPopup] = useState(false);
    const [popupWidget, _setPopupWidget] = useState<null | WidgetCode>(null);
    const [_suggestions, setSuggestions] = useState<string[]>([]);
    const [popupTitle, _setPopupTitle] = useState('');

    const [_levelLabel, setLevelLabel] = useState<string>('Level');
    const [_activeLevelFilter, setActiveLevelFilter] = useState<boolean>(false);

    const [_expertiseLabel, setExpertiseLabel] = useState<string>('Expertise');
    const [_activeExpertiseFilter, setActiveExpertiseFilter] = useState<boolean>(false);

    const [_numOfFilter, setNumOfFilter] = useState<number>(0);
    const { expertiseFilterList = [], levelFilterList = [] } = useAppSelector((state: RootState) => state.filter);
    function handleLabel() {
        let countFilter = 0;

        const activeLevelLabel = levelFilterList
            .filter((x) => x.isActive)
            .map((x, i, list) => {
                switch (i) {
                case 0:
                    return x.title;
                case 1:
                    return list.length - 1;
                default:
                    return null;
                }
            })
            .filter(Boolean)
            .join(' + ');

        if (activeLevelLabel === '') {
            setLevelLabel('Level');
            setActiveLevelFilter(false);
        } else {
            countFilter += 1;
            setLevelLabel(activeLevelLabel);
            setActiveLevelFilter(true);
        }

        const activeExpertiseLabel = expertiseFilterList
            .filter((x) => x.isActive)
            .map((x, i, list) => {
                switch (i) {
                case 0:
                    return x.title;
                case 1:
                    return list.length - 1;
                default:
                    return null;
                }
            })
            .filter(Boolean)
            .join(' + ');
        if (activeExpertiseLabel === '') {
            setExpertiseLabel('Expertise');
            setActiveExpertiseFilter(false);
        } else {
            countFilter += 1;
            setExpertiseLabel(activeExpertiseLabel);
            setActiveExpertiseFilter(true);
        }

        setNumOfFilter(countFilter > 0 ? countFilter : 0);
    }
    useEffect(() => {
        handleLabel();
        // eslint-disable-next-line
    }, [levelFilterList, expertiseFilterList]);

    const [getSuggestions] = useLazyQuery<AlgoliaResponse<AlgoliaSuggestionHits, 'stylist_suggestions'>, AlgoliaInput>(
        STYLIST_SUGGESTION,
        {
            onCompleted(response) {
                const tempHits = [...response.stylist_suggestions.hits];
                const tempSuggestions = tempHits.map((item) => item.query);
                setSuggestions(tempSuggestions as string[]);
            },
            onError(error) {
                console.error('get data Failed: ', error);
            },
        },
    );

    const handleGetSuggestions = (input) => {
        getSuggestions({
            variables: {
                query: input || '',
                filters: ``,
                facets: [],
            },
        });
    };

    useEffect(() => {
        handleGetSuggestions(value);
        //eslint-disable-next-line
    }, [value]);

    return (
        <React.Fragment>
            <div id="header-filter" className={classes.filterWrap}>
                {/* <AutoCompleteSearch
                    setInputSearch={setInputSearch}
                    handler={handler}
                    value={value}
                    suggestions={suggestions}
                /> */}
                {/* {showFilter ? (
                    <div className={classes.filter}>
                        <div className={classes.filterSwiperWrapper}>
                            {numOfFilter ? (
                                <div className={classes.firstFilterChipWrap}>
                                    <Chip
                                        classes={{
                                            outlined: classes.chipOutline,
                                            label: classes.chipLabelActive,
                                            icon: classes.chipIconActive,
                                        }}
                                        className={classes.chipActive}
                                        icon={<Badge className={classes.badgeFilter} badgeContent={numOfFilter} />}
                                        label={'Clear Filters'}
                                        variant="outlined"
                                        onClick={handleResetFilter}
                                    />
                                </div>
                            ) : null}
                            <div className={classes.filterChipWrap}>
                                <Chip
                                    classes={{
                                        outlined: classes.chipOutline,
                                        label: activeLevelFilter ? classes.chipLabelActive : classes.chipLabel,
                                        icon: activeLevelFilter ? classes.chipIconActive : classes.chipIcon,
                                    }}
                                    className={activeLevelFilter ? classes.chipActive : ''}
                                    icon={<ExpandMoreIcon />}
                                    label={levelLabel}
                                    variant="outlined"
                                    onClick={() => handleFilterClick(WidgetCode.LevelFilterWidget)}
                                />
                            </div>
                            <div className={classes.filterChipWrap}>
                                <Chip
                                    classes={{
                                        outlined: classes.chipOutline,
                                        label: activeExpertiseFilter ? classes.chipLabelActive : classes.chipLabel,
                                        icon: activeExpertiseFilter ? classes.chipIconActive : classes.chipIcon,
                                    }}
                                    className={activeExpertiseFilter ? classes.chipActive : ''}
                                    icon={<ExpandMoreIcon />}
                                    label={expertiseLabel}
                                    variant="outlined"
                                    disabled={!expertiseFilterList || expertiseFilterList.length === 0}
                                    onClick={() => handleFilterClick(WidgetCode.ExpertiseFilterWidget)}
                                />
                            </div>
                        </div>
                    </div>
                ) : null} */}
            </div>
            {showPopup && (
                <WidgetPopup
                    titlePopup={popupTitle}
                    widgetCode={popupWidget}
                    listItem={[]}
                    onClose={() => setShowPopup(false)}
                    shortPopup
                />
            )}
        </React.Fragment>
    );
}

export default StylistHeaderFilter;
